export default async function UserTypeMaster(clientId) {
    let url = window.UserService + `/api/UserTypeMaster/GetUserTypeByClientId?clientId=${clientId}`
    let response = {}

    let head = {
        "Content-Type": "application/json",
        'accept': '*/*'
    }
    response = await fetch(url, {
        method: "GET",
        headers: head,
        // body: JSON.stringify(senddata)
    }).then(res => res.json()).then(response)
    return response;
}